_getUserDataLanguageAlertBarAcceptedThunk